export const actions = {
    show: 'ver',
    send: 'enviar',
    delete: 'borrar'
}
export const tabs = [
    {id: "/videos",title: 'Videos'},
    {id: "/video-generator",title: 'Generar Video'},
]
export const videosColumns = [
    {
        id: 1,
        header: 'Centro',
        element: 'Text',
        center: true,
    },
    {
        id: 2,
        header: 'Description',
        element: 'Text',
        center: true,
    },
    {
        id: 3,
        header: 'Status',
        element: 'Text',
        center: true,
    },
    {
        id: 4,
        header: 'Acciones',
        element: 'Text',
        center: true,
    }
];

export const generatorColumns = [
    {
        id: 1,
        header: 'Nombre',
        element: 'Text',
        center: true,
    },
    {
        id: 2,
        header: 'Sala',
        element: 'Text',
        center: true,
    },
    {
        id: 3,
        header: 'Programa',
        element: 'Text',
        center: true,
    },
]


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/contants.js